export default "__VITE_ASSET__NGQ_hdkI__"